import Vue from 'vue';
import Router from 'vue-router';
import Home from './views/Home.vue';
import UserService from '@/services/api/user.service';
import UsersView from '@/views/UsersView.vue';
import OrdersView from '@/views/OrdersView.vue';
import OrderCreateView from '@/views/OrderCreateView.vue';
import BlankRouterView from '@/views/BlankRouterView.vue';
import OrderEditView from '@/views/OrderEditView.vue';
import PermissionsView from '@/views/PermissionsView.vue';
import OrderView from '@/views/OrderView.vue';
import CompaniesView from "@/views/CompaniesView.vue";
import DocumentsEditorView from "@/views/DocumentsEditorView.vue";

Vue.use(Router);

export const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '',
      component: Home,
      children: [
        {
          path: '',
          redirect: 'orders'
        },
        {
          path: 'orders',
          component: BlankRouterView,
          children: [
            {
              path: '',
              component: OrdersView
            },
            {
              path: 'new',
              component: OrderCreateView
            },
            {
              path: ':orderUuid/edit',
              component: OrderEditView
            },
            {
              path: ':orderUuid',
              component: OrderView
            },
            {
              path: '/orders/:orderUuid/documents/invoice/create',
              component: DocumentsEditorView
            }
          ]
        },
        {
          path: 'users',
          component: UsersView
        },
        {
          path: 'permissions',
          component: PermissionsView
        },
        {
          path: 'companies',
          component: CompaniesView
        }
      ]
    },
    {
      path: '/login',
      name: 'login',
      component: () => import(/* webpackChunkName: "login" */ './views/Login.vue')
    }
  ]
});

router.beforeEach((to, from, next) => {
  const publicPages = ['/login'];
  const authRequired = !publicPages.includes(to.path);

  const loggedIn = UserService.isLoggedIn();

  if (authRequired && !loggedIn) {
    return next('/login');
  }

  next();
});
